import { QueryClient } from '@tanstack/react-query'

function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false

  const err = error as { status?: number; code?: string }
  if (typeof err?.status === 'number' && [400, 401, 403, 404].includes(err.status)) {
    return false
  }

  const code = String(err?.code || '')
  if (code === '42501' || code.startsWith('PGRST1')) {
    return false
  }

  return true
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: shouldRetryQuery,
    },
  },
})
